import {useScrollToElementId} from "../../Hooks/ScrollHooks";

export const StreamBankAnchorLink = (props) => {

    const {
        anchor = "",
        role,
        children,
        Disabled,
        style,
        className,
    } = props;

    const scrollToElementId = useScrollToElementId();

    const onClick = (e) => {
        if (!Disabled) {
            // Check "open in new window/tab" key modifiers are pressed.
            if (e.ctrlKey || e.metaKey) {
                //run event using the browser's default handling instead of our spa stuff.
                return;
            } else {
                scrollToElementId(anchor);
            }
        }
        e.preventDefault();
    };

    return (
        <a
            className={className}
            role={role}
            style={{
                cursor: Disabled ? "default" : "pointer",
                ...style,
            }}
            onClick={onClick}
            href={`#${anchor}`}
        >
            {children}
        </a>
    );
};
